import * as React from "react";
import { forwardRef } from "react";
const AnalyticsPieIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 51 50",
  "data-category": "sources",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  stroke: "#114A7B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  d: "M28.625 3.125v18.75h18.75c0-4.9728-1.9754-9.7419-5.4917-13.25825C38.3669 5.10044 33.5978 3.125 28.625 3.125"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#1274C4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  d: "M22.375 9.375c-3.7084 0-7.3335 1.0997-10.4169 3.1599-3.08346 2.0603-5.48669 4.9887-6.90583 8.4148-1.41915 3.4261-1.79046 7.1961-1.06699 10.8332.72348 3.6372 2.50924 6.9781 5.13148 9.6003 2.62224 2.6223 5.96314 4.408 9.60034 5.1315 3.6371.7235 7.4071.3522 10.8332-1.067 3.4261-1.4191 6.3545-3.8223 8.4148-6.9058 2.0602-3.0834 3.1599-6.7085 3.1599-10.4169h-18.75z"
}));
const ForwardRef = forwardRef(AnalyticsPieIcon);
ForwardRef.category = "sources";
export default ForwardRef;
export { ForwardRef as AnalyticsPieIcon };